var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrailerLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58504 0C0.893562 0 0.333008 0.560554 0.333008 1.25203V13.5488H1.03647C1.28883 15.5162 2.96974 17.0366 5.00577 17.0366C6.45494 17.0366 7.72421 16.2663 8.4265 15.1129C9.1288 16.2663 10.3981 17.0366 11.8472 17.0366C13.8833 17.0366 15.5642 15.5162 15.8165 13.5488H17.1655L18.6216 11.5813H29.6663V1.25203C29.6663 0.560554 29.1058 0 28.4143 0H1.58504ZM6.95089 13.0346C6.95089 14.1088 6.08003 14.9797 5.00577 14.9797C3.93151 14.9797 3.06065 14.1088 3.06065 13.0346C3.06065 11.9603 3.93151 11.0894 5.00577 11.0894C6.08003 11.0894 6.95089 11.9603 6.95089 13.0346ZM11.8472 14.9797C12.9215 14.9797 13.7924 14.1088 13.7924 13.0346C13.7924 11.9603 12.9215 11.0894 11.8472 11.0894C10.773 11.0894 9.90211 11.9603 9.90211 13.0346C9.90211 14.1088 10.773 14.9797 11.8472 14.9797Z",
    fill: "#03CDEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerLarge);
export default __webpack_public_path__ + "static/media/TrailerLarge.7ea90a8b62da4b6dbebdf48af3e38945.svg";
export { ForwardRef as ReactComponent };